export const List = () => import("./List.vue");
export const UserGroup = () => import("./UserGroup.vue");
export const Access = () => import("./Access.vue");
